// import { CategoryId } from '@/common/constants/commonConstants';

/** 首页tab */
export enum HomeTab {
  /** 优惠卡券 */
  MALL = 'mall',
  /** 骑行卡 */
  RIDE = 'ride',
}

/** 首页tab文案 */
export const HomeTabText: Record<HomeTab, string> = {
  [HomeTab.MALL]: '优惠卡券',
  [HomeTab.RIDE]: '骑行卡',
};

/** 骑行tab */
export enum RideTab {
  /** 单车 */
  BICYCLE = 'bike',
  /** 助力车 */
  MOPED = 'moped',
}

/** 骑行tab文案 */
export const RideTabText: Record<RideTab, string> = {
  [RideTab.BICYCLE]: '单车',
  [RideTab.MOPED]: '助力车',
};

/** 骑行tab channelCode */
export const RideTabChannelCode: Record<RideTab, string> = {
  [RideTab.BICYCLE]: '101000',
  [RideTab.MOPED]: '102000',
};

/** 类目ID到骑行tab的映射 */
// export const CategoryRideTab = {
//   [CategoryId.BIKE]: RideTab.BICYCLE,
//   [CategoryId.EBIKE]: RideTab.MOPED,
// };


/** 订单状态 */
export const OrderStatus = {
  /** 已冻结 */
  FREEZE: -1,
  /** 待支付 */
  PAY: 0,
  /** 已支付 */
  PAID: 1,
  /** 已退款 */
  REFUND: 2,
  /** 已过期 */
  OUTDATE: 3,
  /** 已取消 */
  // CANCEL: 4,
  /** 进行中 */
  ONGOING: 5,
} as const;

export type OrderStatusType = typeof OrderStatus[keyof typeof OrderStatus];

/** 订单状态文本 */
export const OrderStatusText: Record<OrderStatusType, string> = {
  [OrderStatus.FREEZE]: '已冻结',
  [OrderStatus.PAY]: '待支付',
  [OrderStatus.PAID]: '已支付',
  [OrderStatus.REFUND]: '已退款',
  [OrderStatus.OUTDATE]: '已过期',
  // [OrderStatus.CANCEL]: '已取消',
  [OrderStatus.ONGOING]: '进行中',
};

/** 订单状态图片 */
export const OrderStatusImg: Partial<Record<OrderStatusType, string>> = {
  [OrderStatus.REFUND]: 'https://m.hellobike.com/resource/gallery/421/x7YBt3E_RZ.png',
  // [OrderStatus.OUTDATE]: 'https://m.hellobike.com/resource/gallery/238/oWVW5oysTT.png',
};
export const easyBikeAppDownLoadUrl = 'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true&chInfo=ch_share__chsub_CopyLink&fxzjshareChinfo=ch_share__chsub_CopyLink&apshareid=DAEF5627-8D33-4E6E-9CE2-2A0FD137329B&shareBizType=mrfxzw';
